import React from 'react'
import styles from './AudioTabContent.module.scss'
import {AudioSlider} from './AudioSlider'
import {T} from '../../../common/T'
import {useUIGameUserSettingsContext} from '../../../contexts/UIGameUserSettingsContext'

export const AudioTabContent = () => {
    const {volume, setVolume} = useUIGameUserSettingsContext()

    return <div className={styles.container}>
        <div className={styles.heading}><T id='strings:game.settings.audioTab.volume'/></div>
        <div className={styles.volumeContainer}>
            <div className={styles.volumeText}>{(volume * 100).toFixed(0)}</div>
            <div className={styles.volumeSlider}>
                <AudioSlider onChange={setVolume} value={volume}/>
            </div>
        </div>
    </div>
}
